import Select from "react-select";
import { useFormikContext } from "formik";
import InputField from "../../atoms/InputField";
import SubHeading from "../../atoms/SubHeading";
import { optionsTypesInmuebles } from "../../../utils/optionsTypesInmuebles";

const DatosGeneralesSection = () =>{
    const { values, setFieldValue } = useFormikContext();

    const selectedOption = optionsTypesInmuebles.find((opt) => opt.value === values.type) || null;

    return (
        <div className="w-full flex flex-col border border-gray-500 bg-gray-100 p-4 rounded-md">
            <SubHeading text="Datos generales" color="black" />
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 rounded-md">
                <InputField name="name" label="Nombre" placeholder="Nombre del inmueble" />
                <InputField name="address" label="Dirección" placeholder="Direccion del inmueble" />
                <div>
                    <label htmlFor="type" className="block font-bold text-rs-azul">
                        Clasificación
                    </label>
                    <Select
                        name="type"
                        options={optionsTypesInmuebles}
                        value={selectedOption}
                        onChange={(selected) => {
                        setFieldValue("type", selected ? selected.value : null);
                        }}
                        className="h-fit border border-blue-600 rounded-md"
                        classNamePrefix="select"
                        placeholder="Selecciona clasificación..."
                        isClearable
                    />
                </div>
            </div>
        </div>
    );
};

export default DatosGeneralesSection;
